import { ApolloError, gql, QueryResult, QueryTuple, useLazyQuery, useQuery } from '@apollo/client';

import { client } from '../../../../apollo/ApolloConfig';
import { getPolices } from '../../../../utils/gqlPolicesUtil';

export const GET_COURSES_SAVED_ONLY_ID = gql`
  query GetCoursesSavedOnlyId($collectionId: String, $skillId: String) {
    getCoursesSaved(collectionId: $collectionId, skillId: $skillId) {
      coursesSaved {
        courseId
      }
    }
  }
`;

export interface IGetCoursesSavedOnlyIdParams {
  collectionId?: string;
  skillId?: string;
}

export interface IStudentCourseSavedOnlyId {
  courseId: string;
}

export interface IGetCoursesSavedOnlyIdPaginatedResponse {
  coursesSaved: IStudentCourseSavedOnlyId[];
}

export interface IGetCoursesSavedOnlyIdResponse {
  getCoursesSaved: IGetCoursesSavedOnlyIdPaginatedResponse;
}

export interface IGetCoursesSavedOnlyIdRefetchResponse {
  data: IGetCoursesSavedOnlyIdResponse;
  error: ApolloError | undefined;
}

export const useQueryGetCoursesSavedOnlyId = (
  fromCache?: boolean,
  collectionId?: string,
  skillId?: string,
): QueryResult<IGetCoursesSavedOnlyIdResponse, IGetCoursesSavedOnlyIdParams> =>
  useQuery<IGetCoursesSavedOnlyIdResponse, IGetCoursesSavedOnlyIdParams>(GET_COURSES_SAVED_ONLY_ID, {
    variables:
      collectionId || skillId
        ? {
            ...(collectionId && { collectionId }),
            ...(skillId && { skillId }),
          }
        : undefined,
    ...getPolices(fromCache),
  });

export const useLazyGetCoursesSavedOnlyId = (
  fromCache?: boolean,
): QueryTuple<IGetCoursesSavedOnlyIdResponse, IGetCoursesSavedOnlyIdParams> =>
  useLazyQuery<IGetCoursesSavedOnlyIdResponse, IGetCoursesSavedOnlyIdParams>(GET_COURSES_SAVED_ONLY_ID, {
    ...getPolices(fromCache),
  });

export const getCoursesSavedOnlyIdRefetch = async (
  collectionId?: string,
  skillId?: string,
): Promise<IGetCoursesSavedOnlyIdRefetchResponse> => {
  const data = await client.query<IGetCoursesSavedOnlyIdResponse, IGetCoursesSavedOnlyIdParams>({
    query: GET_COURSES_SAVED_ONLY_ID,
    variables:
      collectionId || skillId
        ? {
            ...(collectionId && { collectionId }),
            ...(skillId && { skillId }),
          }
        : undefined,
    fetchPolicy: 'network-only',
  });

  return {
    data: data.data,
    error: data?.error,
  };
};
